import { RefreshCw } from 'lucide-react';
import { useUpdateChecker } from '@/hooks/use-update-checker';
import { cn } from '@/lib/utils';

export function UpdateButton() {
	const { updateAvailable, applyUpdate } = useUpdateChecker();

	if (!updateAvailable) {
		return null;
	}

	return (
		<div className='fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col items-center gap-2'>
			<button
				type='button'
				onClick={applyUpdate}
				className={cn(
					'px-5 py-2.5 rounded-full',
					'bg-black/80 backdrop-blur-md',
					'border border-pink-500/50',
					'text-sm font-medium text-white',
					'flex items-center gap-2',
					'cursor-pointer',
					'hover:bg-black/90 hover:border-pink-400/70',
					'transition-colors duration-200',
					'animate-update-pulse'
				)}
				aria-label='Update available. Refresh to load the latest version.'
			>
				<RefreshCw className='h-4 w-4 text-pink-400' />
				<span>Update Available</span>
			</button>
		</div>
	);
}
